"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptOrDenyRequestTimeOff = void 0;
const util_1 = require("@app/util");
const accept_or_deny_request_1 = __importDefault(require("./accept-or-deny-request"));
const create_ac_1 = require("./util/create-ac");
exports.acceptOrDenyRequestTimeOff = (0, create_ac_1.createAC)(async (dispatch, args) => {
    const _data = Object.assign({}, args.data);
    if ((0, util_1.isDefined)(_data.requestPendingAction)) {
        delete _data.requestPendingAction;
    }
    const result = (await dispatch((0, accept_or_deny_request_1.default)(args)));
    return result;
});
